interface IProps {
    page: number;
    regularOffersCount: number;
    modularHousesOffersCount?: number;
    isLastPage?: boolean;
}

const MODULAR_HOUSE_PER_OFFER_LIST_PAGE = 2;

export const getOfferListModularHousesPayload = (props: IProps) => {
    const {modularHousesOffersCount = 0, isLastPage = false, page, regularOffersCount} = props;

    const isListingWithHouses = regularOffersCount !== 0;
    let offset = isLastPage ? page * MODULAR_HOUSE_PER_OFFER_LIST_PAGE : (page - 1) * MODULAR_HOUSE_PER_OFFER_LIST_PAGE;
    if (!isListingWithHouses) {
        offset = 0;
    }
    const limit = !isListingWithHouses ? modularHousesOffersCount : isLastPage ? modularHousesOffersCount - offset : MODULAR_HOUSE_PER_OFFER_LIST_PAGE;

    return {limit: limit, offset: offset};
};
interface IProps {
    page: number;
    regularOffersCount: number;
    modularHousesOffersCount?: number;
    isLastPage?: boolean;
}

const MODULAR_HOUSE_PER_OFFER_LIST_PAGE = 2;

export const getOfferListModularHousesPayload = (props: IProps) => {
    const {modularHousesOffersCount = 0, isLastPage = false, page, regularOffersCount} = props;

    const isListingWithHouses = regularOffersCount !== 0;
    let offset = isLastPage ? page * MODULAR_HOUSE_PER_OFFER_LIST_PAGE : (page - 1) * MODULAR_HOUSE_PER_OFFER_LIST_PAGE;
    if (!isListingWithHouses) {
        offset = 0;
    }
    const limit = !isListingWithHouses ? modularHousesOffersCount : isLastPage ? modularHousesOffersCount - offset : MODULAR_HOUSE_PER_OFFER_LIST_PAGE;

    return {limit: limit, offset: offset};
};
